import ExpandMore from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  Stack,
  useMediaQuery,
} from "@mui/material";
import DataLabel from "components/DataLabel";
import { useOrderContext } from "context/OrderContext";
import { useEffect, useState } from "react";

const CustomerSummary: React.FC = () => {
  const order = useOrderContext();

  const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const [isExpanded, setIsExpanded] = useState(isLargeScreen);
  useEffect(() => setIsExpanded(isLargeScreen), [isLargeScreen]);

  return (
    <Accordion
      disableGutters
      elevation={0}
      square
      expanded={isExpanded}
      onChange={(_, isExpanded: boolean) => setIsExpanded(!isLargeScreen && isExpanded)}
    >
      <AccordionSummary expandIcon={!isLargeScreen && <ExpandMore />} hidden={isLargeScreen}>
        Kunddata
      </AccordionSummary>

      <AccordionDetails sx={{ px: 2, pb: 1, pt: isLargeScreen ? 1 : 0 }}>
        <Stack
          spacing={1}
          {...(isLargeScreen && {
            direction: "row",
            divider: <Divider orientation="vertical" flexItem />,
            columnGap: 2,
            rowGap: 1,
            flexWrap: "wrap",
          })}
        >
          <DataLabel label="Kundkod">{order.companyCode}</DataLabel>
          <DataLabel label="Kundtyp">{order.customerType}</DataLabel>
          <DataLabel label="Subkundtyp">{order.subCustomerType}</DataLabel>
          <DataLabel label="Avtal">{order.customerContract}</DataLabel>
          <DataLabel label="Kundordernummer">{order.customerOrderNumber}</DataLabel>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};

export default CustomerSummary;
